<template>
  <div>
    <h6 class="title-section">{{ $t("class-student.sub-titulo-tab") }}</h6>
    <div class="card card-next-class-2" v-if="nextClass">
      <div class="left">
        <img src="@/assets/img/girdRequest-2.png" />
        <h6 class="sub-title">
          <span>{{ $t("horario.next-class.nextClass") }}</span>
        </h6>
      </div>
      <div>
        <div class="right">
          <span><icon name="calendar" />{{ nextClass.startDate }}</span>
          <span><icon name="time" />{{ nextClass.hours }}</span>
        </div>
      </div>
      <button
        type="button"
        class="btn btn-primary"
        :class="nextClass && nextClass.linkClass != null ? '' : 'disabled'"
        @click="
          openLinkClassLocal(
            nextClass.linkClass,
            $moment,
            nextClass.startDateValidate,
            nextClass.endDateValidate
          )
        "
      >
        <icon name="video" />{{ $t("horario.next-class.button-pass") }}
      </button>
      <!-- <button type="button" class="btn btn-primary" :class="nextClass && nextClass.linkClass != null? '': 'disabled'"  @click="openLinkClass(nextClass.linkClass)">
                <b-icon icon="camera-video" aria-hidden="true"></b-icon>{{$t('horario.next-class.button-pass')}}
            </button> -->
    </div>
    <div class="card p-4">
      <div class="card-body">
        <b-form inline class="mb-4 align-items-end">
          <b-form-group class="mr-4" :label="$t('class-student.table-columns.Date')" style="max-width: 258px">
            <date-range-picker
              ref="picker"
              opens="right"
              :locale-data="{
                format: 'dd/mm/yyyy',
                applyLabel: $t('reusables.Apply'),
                cancelLabel: $t('reusables.Cancel'),
                customRangeLabel: 'Custom Range',
                daysOfWeek: daysOfWeek,
                monthNames: this.meses,
                firstDay: 1,
              }"
              v-model="dateRange"
              :ranges="ranges"
              @update="getListSelect"
            >
              <!-- <template v-slot:input="picker" style="min-width: 350px;">
                                {{ picker.startDate | date }} - {{ picker.endDate | date }}
                            </template> -->
            </date-range-picker>
          </b-form-group>
<!--           <b-form-group class="mr-2" :label="$t('class-student.status-class')">
            <CustomSelect
              @input="idValueSelectedStatus"
              :options="optionsStatus"
              value="valor"
              label="descripcion"
              :default="$t('filter.text')"
              :defaultValue="null"
              @change="getListSelect"
            />
          </b-form-group> -->
          <b-form-group
            class="mr-2"
            :label="$t('class-student.teacher')"
            style="max-width: 312px"
          >
            <v-autocomplete
              dense
              filled
              :items="items"
              v-model="item"
              :min-len="0"
              :get-label="getLabel"
              :component-item="template"
              @update-items="updateItems"
              :auto-select-one-item="false"
            >
            </v-autocomplete>
          </b-form-group>
          <button
            class="btn btn-icon ml-auto"
            @click="getExportClassTeacher"
            :disabled="isExport"
          >
            <icon name="arrow-download" />
          </button>
        </b-form>
        <b-table-simple
          responsive
          hover
          id="table-request"
          :aria-busy="isBusy"
          :tbody-transition-props="transProps"
          primary-key="id"
          style="white-space: pre-line"
        >
          <b-thead>
            <b-th style="width: 15%">{{
              $t("class-student.table-columns.ClassState")
            }}</b-th>
            <b-th style="width: 8%">{{
              $t("class-student.table-columns.Date")
            }}</b-th>
            <b-th style="width: 20%">{{
              $t("class-student.table-columns.Hour")
            }}</b-th>
            <b-th style="width: 11%">{{
              $t("class-student.table-columns.Duration")
            }}</b-th>
            <b-th style="width: 8%">{{
              $t("class-student.table-columns.HoursUsed")
            }}</b-th>
            <b-th class="text-center">{{
              $t("class-student.table-columns.Teacher")
            }}</b-th>
            <b-th style="width: 11%">{{
              $t("class-student.table-columns.ClassReports")
            }}</b-th>
          </b-thead>
          <b-tbody>
            <b-tr v-if="isBusy" class="b-table-busy-slot">
              <b-td colspan="10">
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong> {{$t('ClassRequest.Loading')}}...</strong>
                </div>
              </b-td>
            </b-tr>
            <b-tr v-else>
              <b-td colspan="10" v-if="itemsTable.length == 0">{{ $t('reusables.empty-text') }}</b-td>
            </b-tr>
            <b-tr v-for="(row, i) of itemsTable" :key="i">
              <template v-if="row.isTotal == true">
                <b-td colspan="10" class="data-package">
                  <span class="d-flex align-items-center justify-content-center"
                    >{{ $t("class-student.table-columns.Package") }}:
                    {{
                      row.groupPlan.flagPlanTest
                        ? $t("reusables.test-class")
                        : ("" + row.groupPlan.duration)
                            .concat(" ")
                            .concat($t("class-student.table-columns.Hours"))
                    }}
                    |
                    {{ $t("class-student.table-columns.PurchaseDate") }}:
                    {{ row.groupPlan.strPurchaseDate }}
                  </span>
                </b-td>
              </template>

              <template v-else>
                <b-td>
                  <label :style="{ color: row.statusColor }">{{
                    row.status
                  }}</label></b-td
                >
                <b-td>
                  <label>{{ row.date }}</label>
                </b-td>
                <b-td>
                  <label>{{ row.hours }}</label></b-td
                >
                <b-td>
                  <label>{{ row.strClassDuration }}</label></b-td
                >
                <b-td v-if="row.hoursUse > 0 && row.duration > 0">{{
                  row.hoursUse + "/" + row.duration
                }}</b-td>
                <b-td v-else>-</b-td>
                <b-td
                  v-if="
                    row.personsTeachersPendingPaymentClassId > 0 &&
                    row.personsTeacher != null
                  "
                  >{{ row.personsTeacher.strFullName }}</b-td
                >
                <b-td v-else>-</b-td>
                <b-td
                  ><div
                    v-if="getShowReport(row.statusValue, row.groupPlanClassId)"
                    class="d-flex justify-content-center"
                  >
                    <router-link
                      :to="{
                        name: 'student-class-report',
                        params: {
                          id: row.groupPlanClassId,
                          flagReport: false,
                        },
                      }"
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      "
                      class="bold"
                    >
                      {{ row.report }}
                    </router-link>
                  </div>
                  <div v-else>
                    <span>
                      {{ row.report }}
                    </span>
                  </div></b-td
                >
              </template>
            </b-tr>
          </b-tbody>
        </b-table-simple>
        <div class="content-pagination">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="pageSize"
            align="fill"
            size="sm"
            class="my-0"
          ></b-pagination>
          {{ (currentPage - 1) * pageSize + 1 }} -
          {{
            pageSize > totalRows
              ? totalRows
              : pageSize * currentPage > totalRows
              ? totalRows
              : pageSize * currentPage
          }}
          /{{ totalRows }} items
        </div>
      </div>
    </div>
    <b-modal id="modal-next-linkClass" :centered="true">
      <template #modal-header="{ close }">
        <img class="close" src="@/assets/img/close_red.png" @click="close()" />
      </template>
      <p class="text-center mb-0">{{ messageLinkClassResult }}</p>
      <template #modal-footer>
        <b-button
          @click="$bvModal.hide('modal-next-linkClass')"
          variant="primary"
          >Aceptar</b-button
        >
      </template>
    </b-modal>
  </div>
</template>
<script>
import { baseInstanceAxios } from "@/assets/js/axiosBase.js";
import * as Constants from "@/assets/js/appConstants";
import {
  horarioObtenerColorClaseConsolidado,
  horarioObtenerNameClaseEnEsConsolidado,
  openLinkClass,
  getNextClassDate,
  getNextClassTime,
  convertTimeToUserTimeFormat,
} from "@/assets/js/util.js";
import DateRangePicker from "vue2-daterange-picker";
import ItemTemplate from "@/views/student/class/ItemTemplate";
import CustomSelect from "@/components/form/select";

import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

const lang = localStorage.getItem("lang") || "es";
let today = new Date();
today.setHours(0, 0, 0, 0);

let yesterday = new Date();
yesterday.setDate(today.getDate() - 1);
yesterday.setHours(0, 0, 0, 0);

let thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
let thisMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);

export default {
  components: { DateRangePicker },
  data() {
    return {
      isExport: false,
      dateRange: { startDate: null, endDate: null },
      ranges:
        lang == "es"
          ? {
              Hoy: [today, today],
              Ayer: [yesterday, yesterday],
              "Este mes": [thisMonthStart, thisMonthEnd],
              "Este año": [
                new Date(today.getFullYear(), 0, 1),
                new Date(today.getFullYear(), 11, 31),
              ],
              "Último mes": [
                new Date(today.getFullYear(), today.getMonth() - 1, 1),
                new Date(today.getFullYear(), today.getMonth(), 0),
              ],
            }
          : {
              Today: [today, today],
              Yesterday: [yesterday, yesterday],
              "This month": [thisMonthStart, thisMonthEnd],
              "This year": [
                new Date(today.getFullYear(), 0, 1),
                new Date(today.getFullYear(), 11, 31),
              ],
              "Last month": [
                new Date(today.getFullYear(), today.getMonth() - 1, 1),
                new Date(today.getFullYear(), today.getMonth(), 0),
              ],
            },
      nextClass: null,
      messageLinkClassResult: null,
      currentPage: 1,
      pageSize: 50,
      totalRows: 0,
      transProps: {
        // Transition name
        name: "flip-list",
      },
      isBusy: false,
      //optionsClass: [],
      optionsStatus: [],
      selectedStatus: null,
      //selectedClass : null,
      itemsTable: [],
      openLinkClass: openLinkClass,
      template: ItemTemplate,
      item: null,
      items: [],
      lang: localStorage.getItem("lang"),
      meses:
        localStorage.getItem("lang") == "es"
          ? Constants.MESES.ES
          : Constants.MESES.EN,
      daysOfWeek:
        localStorage.getItem("lang") == "es"
          ? Constants.DIA_SEMANA_SHORT.ES
          : Constants.DIA_SEMANA_SHORT.EN,
    };
  },
  computed: {
    groupId: {
      get() {
        return this.$store.state.group_id;
      },
      set(value) {
        this.$store.commit("mutateGroupId", value);
      },
    },
    User: {
      get() {
        return this.$store.state.user;
      },
    },
  },
  watch: {
    currentPage() {
      this.isBusy = true;
      this.getListClassTeacher();
    },
  },
  created() {
    let startDate = this.$moment().toDate();
    let endDate = this.$moment().subtract(1, "months").toDate();
    this.dateRange = {
      startDate: endDate,
      endDate: startDate,
    };
    this.isBusy = true;
    this.getListClassTeacher();
    //this.getListCombo();
  },
  mounted() {},
  methods: {
    idValueSelectedStatus(event) {
      this.selectedStatus = event;
    },
    getLabel(item) {
      this.item = item;
      this.getListClassTeacher();
      return item?.name;
    },
    updateItems(text) {
      var that = this;
      let data = {
        idGroup: this.groupId,
        filter: text,
      };
      that.items = [];
      baseInstanceAxios
        .get(
          `${this.apiURL}/resources/PersonsStudents/ComboTeacherByAutocomplete`,
          {
            params: data,
          }
        )
        .then(function (response) {
          if (response.data && response.data.list) {
            that.items = response.data.list.map((x) => ({
              id: x.id,
              name: x.descripcion,
            }));
          }
        });
    },
    getListSelect() {
      this.isBusy = true;
      this.itemsTable = [];
      this.currentPage = 1;
      this.getListClassTeacher();
    },
    getListClassTeacher() {
      let data = {
        Page: this.currentPage,
        Size: this.pageSize,
        //GroupId : this.groupId,
        TeacherId: this.item ? this.item.id : null,
        StateClassId: this.selectedStatus,
        FechaIni: this.$moment(this.dateRange.startDate).format(
          "YYYY-MM-DDT00:00:00"
        ),
        FechaFin: this.$moment(this.dateRange.endDate).format(
          "YYYY-MM-DDT23:59:59"
        ),
      };

      if (this.$store.state.is_admin) {
        data.GroupId = this.groupId;
        data.PersonStudentId = 0;
      } else {
        data.GroupId = 0;
        data.PersonStudentId = this.User.personStudentId;
      }

      let format_day = "DD/MM/YYYY";
      let format_time = "h:mm a";
      baseInstanceAxios
        .get(
          `${this.apiURL}/resources/PersonsStudents/GetListStudentScheduleDetailClass`,
          { params: data }
        )
        .then((response) => {
          console.log(response.data.entity.listGroupScheduleStudentDetail);
          if (response.data.entity.listGroupScheduleStudentDetail != null) {
            this.totalRows = response.data.rows;
            let data = [];
            if (this.currentPage != 1)
              data[(this.currentPage - 1) * this.pageSize - 1] = {};

            let dataResponse =
              response.data.entity.listGroupScheduleStudentDetail.map((x) => {
                if (x.isTotal) {
                  return {
                    id: x.id,
                    isTotal: x.isTotal,
                    groupPlan: x.groupPlan,
                    groupPlanClassId: x.groupPlanClassId,
                  };
                } else {
                  return {
                    hoursUse:x.hoursUse,
                    groupPlanId:x.groupPlanId,
                    id: x.id,
                    isTotal: x.isTotal,
                    noSchedule: x.noSchedule,
                    totalHoursSchedule: x.totalHoursSchedule,
                    duration: x.duration,
                    strClassDuration: x.strClassDuration,
                    personsTeachersPendingPaymentClassId:
                      x.personsTeachersPendingPaymentClassId,
                    personsTeacher:
                      x.personsTeacher != null ? x.personsTeacher.person : null,
                    status: horarioObtenerNameClaseEnEsConsolidado(
                      x.stateClass.strValue
                    ),
                    statusValue: x.stateClass.value,
                    statusColor: horarioObtenerColorClaseConsolidado(
                      x.stateClass.strValue
                    ),
                    startDate: x.startDate,
                    endDate: x.endDate,
                    date: getNextClassDate(
                      x.startDate,
                      this.$store.state.user.timeZoneName,
                      this.$moment,
                      format_day
                    ),
                    hours: getNextClassTime(
                      x.startDate,
                      x.endDate,
                      this.$store.state.user.timeZoneName,
                      this.$moment,
                      format_time
                    ),
                    teacher: x.className,
                    groupPlanClassId: x.groupPlanClassId,
                    subjects:
                      this.lang == "es"
                        ? x.subjectsName.replaceAll("|", "\n")
                        : x.subjectsName_EN.replaceAll("|", "\n"),
                    report: this.getValidationColumnReport(
                      x.stateClass.value,
                      x.groupPlanClassId
                    ),
                    _rowVariant: "end-package", //colocar este campo al último row del pack
                  };
                }
              });

            const bestBySlot = {};
            dataResponse.forEach(row => {
              if (!row || row.isTotal) return;
              const key = `${row.startDate}_${row.endDate}`;
              const score = (row.hoursUse > 0 ? 4 : 0) + (row.personsTeachersPendingPaymentClassId > 0 ? 2 : 0) + (row.groupPlanClassId > 0 ? 1 : 0);
              if (!bestBySlot[key] || score > bestBySlot[key].score) {
                bestBySlot[key] = { row, score };
              }
            });
            const dedupedResponse = dataResponse.filter(row => {
              if (!row || row.isTotal) return true;
              const key = `${row.startDate}_${row.endDate}`;
              return bestBySlot[key].row === row;
            });

            this.itemsTable = dedupedResponse;
          }
          let format_time_validate = "YYYY-MM-DDTHH:mm:ss";

          if (response.data.entity.nextClass != null) {
            this.nextClass = {
              className: response.data.entity.nextClass.className,
              stateClass: response.data.entity.nextClass.stateClass,
              linkClass: response.data.entity.nextClass.linkClass,
              hours: getNextClassTime(
                response.data.entity.nextClass.startDate,
                response.data.entity.nextClass.endDate,
                this.$store.state.user.timeZoneName,
                this.$moment,
                format_time
              ),
              startDate: getNextClassDate(
                response.data.entity.nextClass.startDate,
                this.$store.state.user.timeZoneName,
                this.$moment,
                format_day
              ),
              classPhoto:
                response.data.entity.nextClass.teacherPhoto != null
                  ? response.data.entity.nextClass.teacherPhoto
                  : "",
              startDateValidate: convertTimeToUserTimeFormat(
                response.data.entity.nextClass.startDate,
                this.$store.state.user.timeZoneName,
                this.$moment,
                format_time_validate
              ),
              endDateValidate: convertTimeToUserTimeFormat(
                response.data.entity.nextClass.endDate,
                this.$store.state.user.timeZoneName,
                this.$moment,
                format_time_validate
              ),
            };
          }

          this.isBusy = false;
        });
    },
    getExportClassTeacher() {
      this.isExport = true;
      let data = {
        TeacherId: this.item ? this.item.id : null,
        StateClassId: this.selectedStatus,
        FechaIni: this.$moment(this.dateRange.startDate).format(
          "YYYY-MM-DDT00:00:00"
        ),
        FechaFin: this.$moment(this.dateRange.endDate).format(
          "YYYY-MM-DDT23:59:59"
        ),
        timeZoneName: this.$store.state.user.timeZoneName,
        flagLanguage: this.lang == "es" ? true : false,
      };

      if (this.$store.state.is_admin) {
        data.GroupId = this.groupId;
        data.PersonStudentId = 0;
      } else {
        data.GroupId = 0;
        data.PersonStudentId = this.User.personStudentId;
      }
      let headers = {
        responseType: "blob",
      };
      baseInstanceAxios
        /*   .get(
          `${this.apiURL}/resources/PersonsStudents/ExportarListStudentScheduleDetailClass?
          GroupId=${data.GroupId}
          &PersonStudentId=${data.PersonStudentId}
          &TeacherId=${data.TeacherId}
          &StateClassId=${data.StateClassId}
          &FechaIni=${data.FechaIni}
          &FechaFin=${data.FechaFin}
          &timeZoneName=${data.timeZoneName}
          &flagLanguage=${data.flagLanguage}`,
          headers
        ) */
        .get(
          `${this.apiURL}/resources/PersonsStudents/ExportarListStudentScheduleDetailClass`,
          {
            params: data,
            responseType: "blob",
          }
        )
        .then((response) => {
          var data = response.data;
          if (data != null) {
            const url = window.URL.createObjectURL(new Blob([data]));
            const today = new Date().toLocaleDateString();
            const now = Date.now();
            const name = `ClassReport_${today}_${now}`;
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${name}.xlsx`);
            document.body.appendChild(link);
            link.click();
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.isExport = false;
        });
    },
    getShowReport(state, groupPlanClassId) {
      let states = [Constants.CALENDAR_STATUS.COMPLETED.VALUE];

      return states.includes(state) && groupPlanClassId;
    },
    getValidationColumnReport(state, groupPlanClassId) {
      let textReturn = "";

      switch (state) {
        case Constants.CALENDAR_STATUS.PENDIENT.VALUE:
        case Constants.CALENDAR_STATUS.CONFIRM.VALUE:
        case Constants.CALENDAR_STATUS.UNAVAILABLE.VALUE:
          textReturn = "-";
          break;
        case Constants.CALENDAR_STATUS.CANCELED_TEACHER.VALUE:
        case Constants.CALENDAR_STATUS.CANCELED_STUDENT.VALUE:
        case Constants.CALENDAR_STATUS.PENDING_REPORT.VALUE:
          textReturn = "-";
          break;
        case Constants.CALENDAR_STATUS.UNATTENDANCE_TEACHER.VALUE:
        case Constants.CALENDAR_STATUS.UNATTENDANCE_STUDENT.VALUE:
          textReturn = "-";
          break;
        case Constants.CALENDAR_STATUS.COMPLETED.VALUE:
          textReturn = this.$t("my-class.index.option-see");
          break;
      }

      return textReturn;
    },
    openLinkClassLocal(linkClass, moment, startDate, endDate) {
      this.messageLinkClassResult = null;
      let result = openLinkClass(
        linkClass,
        moment,
        startDate,
        endDate,
        this.$store.state.user.timeZoneName
      );
      if (result != "") {
        this.messageLinkClassResult = result;
        this.$bvModal.show("modal-next-linkClass");
      }
    },
    getListCombo() {
      let data = {};

      if (this.$store.state.is_admin) {
        data.GroupId = this.groupId;
        data.PersonStudentId = 0;
      } else {
        data.GroupId = 0;
        data.PersonStudentId = this.User.personStudentId;
      }

      baseInstanceAxios
        .get(
          `${this.apiURL}/resources/PersonsStudents/GetListStudentScheduleDetailClassCombo`,
          { params: data }
        )
        .then((response) => {
          let optionStatus = response.data.entity.listStatusClass;

          optionStatus.forEach((element) => {
            this.optionsStatus.push({
              valor: element.valor,
              descripcion: horarioObtenerNameClaseEnEsConsolidado(
                element.valor
              ),
            });
          });
        });
    },
  },
};
</script>